import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./VerifyModal.css";
const VerifyModal = ({
  show,
  onHide,
  title,
  message,
  buttonText,
  onButtonClick,
   gifSrc,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"             // Makes the modal large
      centered
      backdrop="true"
      dialogClassName="verification-modal"
    >
      <div className="text-center border-0 modal-box">
      
        <h3 className="fw-bold mb-3">{title}</h3>
        <p className="fw-normal mb-0">{message}</p>
        <Button
          variant="primary"
          className="fw-semibold w-100 margin-50"
          onClick={onButtonClick || onHide}
        >
          {buttonText}
        </Button>
      </div>
    </Modal>
  );
};

export default VerifyModal;
